import * as Sentry from '@sentry/nuxt'

Sentry.init({
  dsn: 'https://6678a41aefaba7d057807ff160f7ead6@o4507764207386624.ingest.us.sentry.io/4507763712196608',
})
